export default __webpack_public_path__ + "static/stephen-8c8ce7ac128b9bfc04001420173fd352.png";